var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"20px"}},[_c('h2',[_vm._v("Google Address Test")]),_c('place-autocomplete',{attrs:{"placeholder":"Type address here"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }